import {type GameSettings} from '@colonist/game-base-types'
import {
    type ScenarioSettingEnum,
    type ExtensionSettingEnum,
    type GameTypeEnum,
    type ModeSettingEnum,
    type MapSettingEnum,
    type DiceSettingEnum,
    type GameSpeedSettings,
    type BotSpeedSettings,
    type ELOTypeEnum,
    type NonFunctionProperties,
} from '@colonist/types'
import {type StateCreator} from 'zustand'

export interface GameSettingsSlice {
    gameSettings: {
        roomId: string
        gameType: GameTypeEnum
        isPrivateGame: boolean
        isPlayOrderSelectionActive: boolean
        minimumKarma: number
        eloType: ELOTypeEnum

        modeSetting: ModeSettingEnum
        extensionSetting: ExtensionSettingEnum
        scenarioSetting: ScenarioSettingEnum
        mapSetting: MapSettingEnum
        diceSetting: DiceSettingEnum

        victoryPointsToWin: number
        isKarmaActive: boolean
        setIsKarmaActive: (isKarmaActive: boolean) => void
        cardDiscardLimit: number
        maxPlayers: number
        gameSpeed: GameSpeedSettings
        botSpeed: BotSpeedSettings
        hideBankCards: boolean
        friendlyRobber: boolean
    }
}

export interface GameSettingsSliceProps {
    initialGameSettings: NonFunctionProperties<GameSettings>
}

export const createGameSettingsSlice = ({
    initialGameSettings,
}: GameSettingsSliceProps): StateCreator<GameSettingsSlice> => (set, get) => ({
    gameSettings: {
        roomId: initialGameSettings.id,
        gameType: initialGameSettings.gameType,
        isPrivateGame: initialGameSettings.privateGame,
        isPlayOrderSelectionActive: initialGameSettings.playOrderSelectionActive,
        minimumKarma: initialGameSettings.minimumKarma,
        eloType: initialGameSettings.eloType,

        modeSetting: initialGameSettings.modeSetting,
        extensionSetting: initialGameSettings.extensionSetting,
        scenarioSetting: initialGameSettings.scenarioSetting,
        mapSetting: initialGameSettings.mapSetting,
        diceSetting: initialGameSettings.diceSetting,

        victoryPointsToWin: initialGameSettings.victoryPointsToWin,
        isKarmaActive: initialGameSettings.karmaActive,
        setIsKarmaActive: (isKarmaActive: boolean) => {
            set({gameSettings: {
                ...get().gameSettings,
                isKarmaActive: isKarmaActive,
            }})
        },
        cardDiscardLimit: initialGameSettings.cardDiscardLimit,
        maxPlayers: initialGameSettings.maxPlayers,
        gameSpeed: initialGameSettings.gameSpeed,
        botSpeed: initialGameSettings.botSpeed,
        hideBankCards: initialGameSettings.hideBankCards,
        friendlyRobber: initialGameSettings.friendlyRobber,
    },
})
